import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReportFieldDefinitionsService } from '../../services/report-field-definitions.service';

@Component({
  selector: 'app-field-help-icon',
  standalone: true,
  imports: [MatIconModule, MatTooltipModule],
  templateUrl: './field-help-icon.component.html',
  styleUrls: ['./field-help-icon.component.scss']
})
export class FieldHelpIconComponent {
  @Input() fieldKey: string = '';
  @Input() customTooltip: string = '';

  constructor(private fieldDefinitionsService: ReportFieldDefinitionsService) {}

  get tooltipText(): string {
    if (this.customTooltip) {
      return this.customTooltip;
    }
    return this.fieldDefinitionsService.getTooltip(this.fieldKey);
  }
}
